module.exports = __webpack_public_path__ + "img/modal-2-mock.a29d8399.png";